module.exports = __webpack_public_path__ + "static/media/20.93724aff.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/20.png
// module id = 1262
// module chunks = 0